export class ElementColors {
  static Base = {
    Primary: "primary",
    Secondary: "secondary",
    Accent: "accent",
    Error: "error",
    Warning: "warning",
    Info: "info",
    Success: "success",
  };
  static Chip = {
    Successful: "chipSuccessful",
    Pending: "chipPending",
    PaidAtPos: "chipPaidAtPos",
    VoidAtPos: "chipVoidAtPos",
    NotInitiated: "chipNotInitiated",
    Submitted: "chipSubmitted",
    Picked: "chipPicked",
    Collected: "chipCollected",
    Cancelled: "chipCancelled",
    ClickAndCollect: "chipClickAndCollect",
    Delivery: "chipDelivery",
    Urgent: "chipUrgent",
    Default: "chipDefault",
    Text: "chipText",
    AgeRestriction: "chipAgeRestriction",
  };
  static Button = {
    Text: "buttonText",
    No: "buttonNo",
    Close: "buttonClose",
  };
}
